/* GN — card "Più ne prendi, meno paghi" nella scheda prodotto: si ricalcola quando cambia il carrello.
   Stessa logica del messaggio di snippets/gn-tiers-card.liquid (le stampe si riconoscono dal tipo prodotto). */
const UPDATE = 'cart:update';

class GnTiers extends HTMLElement {
  connectedCallback() {
    if (!this.hasAttribute('data-live')) return;
    this.onUpdate = (event) => this.refresh(event);
    document.addEventListener(UPDATE, this.onUpdate);
    document.addEventListener('shopify:cart:lines-update', this.onUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener(UPDATE, this.onUpdate);
    document.removeEventListener('shopify:cart:lines-update', this.onUpdate);
  }

  async refresh(event) {
    // Aspetta che il carrello sia stato davvero aggiornato prima di rileggerlo:
    // l'evento di Horizon porta la promise dell'operazione; in mancanza, una breve attesa.
    const pending = event?.promise || event?.detail?.promise;
    if (pending) await Promise.resolve(pending).catch(() => {});
    else await new Promise((resolve) => setTimeout(resolve, 800));
    await new Promise((resolve) => setTimeout(resolve, 150));
    let cart;
    try { cart = await (await fetch(`${window.Theme?.routes?.cart_url || '/cart'}.js`, { headers: { Accept: 'application/json' } })).json(); } catch { return; }
    const types = (this.dataset.types || 'Stampa').split(',').map((t) => t.trim().toLowerCase());
    const count = cart.items.filter((i) => types.includes(String(i.product_type).toLowerCase())).reduce((n, i) => n + i.quantity, 0);
    this.render(count);
  }

  render(count) {
    const qtys = this.dataset.qtys.split(',').map(Number);
    const pcts = this.dataset.pcts.split(',').map(Number);
    const plus = Number(this.dataset.plus) || 0;
    const total = count + plus;
    let cur = 0;
    let next = 0;
    let nextPct = 0;
    qtys.forEach((q, i) => {
      if (total >= q) cur = pcts[i];
      else if (!next) { next = q; nextPct = pcts[i]; }
    });

    this.querySelectorAll('.gn-tc__tier').forEach((li) => {
      const q = Number(li.dataset.qty);
      li.classList.toggle('is-reached', total >= q);
      li.classList.toggle('is-next', q === next);
    });
    const bar = this.querySelector('.gn-tc__bar span');
    if (bar) bar.style.width = `${Math.min(100, Math.round((total / qtys[qtys.length - 1]) * 100))}%`;

    const lead = `${plus ? 'Con questa sei a ' : 'Sei a '}${total === 1 ? '1 stampa' : `${total} stampe`}`;
    const missing = next - total;
    const msg = this.querySelector('[data-gn-tc-msg]');
    if (!msg) return;
    msg.innerHTML = !next
      ? `${lead}: hai il <strong>-${cur}%</strong>. Mo' sì che ragioniamo.`
      : `${lead}${cur ? ` e hai già il -${cur}%` : ''}. <strong>${missing === 1 ? "Aggiungine un'altra, anche diversa," : `Aggiungine altre ${missing}, anche diverse,`} e scatta il -${nextPct}%.</strong>`;
    this.dataset.count = String(count);
  }
}

if (!customElements.get('gn-tiers')) customElements.define('gn-tiers', GnTiers);
